import { Component, Inject, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { environment } from 'src/app/environments/environments';
import { UserRegDetails } from 'src/app/models/user';
import {
  EncryptionService,
  UserDetailsToken,
} from 'src/app/services/Encryption/encryption.service';

@Component({
  selector: 'app-lodge-complaint-diaog',
  templateUrl: './lodge-complaint-diaog.component.html',
  styleUrls: ['./lodge-complaint-diaog.component.scss'],
})
export class LodgeComplaintDiaogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: UserRegDetails[],
    private formbuilder: FormBuilder,
    private encryptionService: EncryptionService
  ) {}
  adminFilter = new FormControl();
  filteredAdmins: UserRegDetails[] = [];
  selectedOption: string;
  attachmentContent: string = null;
  isEmployee = false;
  isSupport = false;
  // selectedAttachment: File | null = null;
  selectedAttachments: File[] = [];
  statusOptions: string[] = ['Open', 'Close', 'Verified'];
  lodgeComplaintTicket = this.formbuilder.group({
    Assignee: [''],
    assignedAdminId: [''],
    assignedAdminName: [''],
    complainSubject: [null, Validators.required],
    requestType: [null],
    complainDescription: ['', Validators.required],
    incidentCriticality: ['', Validators.required],
    claimAmount: [''],
    claimType: [''],
    attachments: [],
    leaveType: ['1'],
    singleDate: [new Date()],
    startDate: [new Date()],
    endDate: [new Date()],
    multipleDate: [],
    isRecurring: false,
    selectedFrequency: [''],
    selectedDays: new FormControl([]), // Add this control
    selectedDates: new FormControl([]),
    SelectedUsers: this.formbuilder.array([], Validators.required),
  });
  readonly range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  selectedUsersControl = new FormControl();
  filteredAssignee: UserRegDetails[] = [];
  usersTemp: string[] = [];
  disabledOrgIds: string[] = [];
  isDisableFeature: boolean = false;
  loggedUser: UserDetailsToken;
  orgId: string = null;
  ngOnInit() {
    this.loggedUser = this.encryptionService.getCurrentUser();
    this.isEmployee = this.loggedUser.isEmployee;
    this.orgId = this.loggedUser.organizationID.toLowerCase();
    this.filteredAdmins = this.data;
    this.filteredAssignee == this.data;
    this.selectedUsersControl.valueChanges.subscribe((value) => {
      this.filteredAssignee = this.filterHosts(value);
    });

    // Subscribe to value changes in the filter input
    this.adminFilter.valueChanges.subscribe((value) => {
      this.filteredAdmins = this.filterHosts(value);
    });
    this.disabledOrgIds = environment.printerAllowed;
    this.isDisableFeature = this.disabledOrgIds
      .map((id) => id.toLowerCase())
      .includes(this.orgId);
  }
  onChangeSelectedRadio(val: any) {
    const isMultiple = val.value == '2';
    this.lodgeComplaintTicket.get('singleDate').clearValidators();
    this.lodgeComplaintTicket.get('endDate').clearValidators();

    this.lodgeComplaintTicket
      .get('singleDate')
      .setValidators(isMultiple ? null : [Validators.required]);

    this.lodgeComplaintTicket
      .get('endDate')
      .setValidators(isMultiple ? [Validators.required] : null);
    this.lodgeComplaintTicket.get('singleDate').updateValueAndValidity();
    this.lodgeComplaintTicket.get('endDate').updateValueAndValidity();
  }
  onChangeComplainType(val: any) {
    const isClaimSelected = val.value === 'Claim';
    const isLeaveRequest = val.value === 'Leave';
    this.isSupport = val.value === 'Support';
    const isRequest = val.value === 'Service Request';

    if (this.isSupport) {
      const matchedUser = this.data.find(
        (user) => user.userId === localStorage.getItem('AumyeId')
      );
      this.usersTemp.push(matchedUser.firstname);
      const item = {
        HostName:
          matchedUser.firstname.trim() + ' ' + matchedUser.lastname.trim(),
        HostUserId: matchedUser.userId,
        HostEmail: matchedUser.email,
        HostPhone: matchedUser.phoneNumber,
      };
      this.selected.push(this.formbuilder.control(item));
      this.lodgeComplaintTicket.get('Assignee').disable();
    } else {
      this.lodgeComplaintTicket.get('Assignee').enable();
    }

    this.lodgeComplaintTicket
      .get('requestType')
      .setValidators(isRequest ? [Validators.required] : null);

    this.lodgeComplaintTicket
      .get('leaveType')
      .setValidators(isLeaveRequest ? [Validators.required] : null);
    this.lodgeComplaintTicket
      .get('singleDate')
      .setValidators(isLeaveRequest ? [Validators.required] : null);

    this.lodgeComplaintTicket
      .get('claimType')
      .setValidators(isClaimSelected ? [Validators.required] : null);
    this.lodgeComplaintTicket
      .get('claimAmount')
      .setValidators(isClaimSelected ? [Validators.required] : null);

    // Update the validity status of the form control
    this.lodgeComplaintTicket.get('claimType').updateValueAndValidity();
    this.lodgeComplaintTicket.get('claimAmount').updateValueAndValidity();
  }
  filterHosts(value: string) {
    // Implement your filtering logic here
    const filterValue = value.toLowerCase();
    return this.data.filter((host) =>
      `${host.firstname} ${host.lastname}`.toLowerCase().includes(filterValue)
    );
  }
  inputValidator(event: { charCode: number }) {
    return (
      (event.charCode != 8 && event.charCode == 0) ||
      (event.charCode >= 48 && event.charCode <= 57)
    );
  }
  adminSelect(val: MatAutocompleteSelectedEvent) {
    this.data.forEach((item) => {
      if (item.firstname + ' ' + item.lastname === val.option.value) {
        this.lodgeComplaintTicket.controls.assignedAdminId.setValue(
          item.userId
        );
        this.lodgeComplaintTicket.controls.assignedAdminName.setValue(
          item.firstname.trim() + ' ' + item.lastname.trim()
        );
      }
    });
  }
  // onAttachmentSelected(event: any): void {
  //   const fileInput = event.target;
  //   if (fileInput.files && fileInput.files.length > 0) {
  //     this.selectedAttachment = fileInput.files[0];
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       const contents = e.target.result as string;
  //       this.attachmentContent = contents;
  //     };
  //     reader.readAsDataURL(this.selectedAttachment);
  //   } else {
  //     this.selectedAttachment = null;
  //   }
  // }
  // onAttachmentSelected(event: any): void {
  //   const files: FileList = event.target.files;
  //   for (let i = 0; i < files.length; i++) {
  //     this.selectedAttachments.push(files[i]);
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       const contents = e.target.result as string;
  //       this.attachmentContent = contents;
  //     };
  //     reader.readAsDataURL(this.selectedAttachment);
  //     this.lodgeComplaintTicket
  //       .get('attachments')
  //       .setValue(this.selectedAttachments);
  //     console.log(this.lodgeComplaintTicket.value);
  //   }
  // }
  selectedMultipleAttachment: ISelectedAttachments[] = [];
  onAttachmentSelected(event: any): void {
    const files: FileList = event.target.files;
    const attachedContents: string[] = []; // Array to store file contents (optional)
    for (let i = 0; i < files.length; i++) {
      this.selectedAttachments.push(files[i]);
      const file = files[i];
      const reader = new FileReader();

      reader.onload = (e) => {
        const contents = e.target.result as string;
        attachedContents.push(contents); // Add content to the array (optional)
        this.selectedMultipleAttachment.push({
          selectedAttachment: file,
          attachedContent: contents,
          attachedContentName: file.name,
          attachedContentType: file.type,
        });
        this.lodgeComplaintTicket
          .get('attachments')
          .setValue(this.selectedMultipleAttachment);
      };
      reader.readAsDataURL(file);
      this.lodgeComplaintTicket
        .get('attachments')
        .setValue(this.selectedMultipleAttachment); // Update form control
    }
  }
  selectedFrequency: string;
  selectedDays: string[] = [];
  selectedDates: number[] = [];
  daysOfWeek: string[] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  datesOfMonth: number[] = Array.from({ length: 31 }, (_, i) => i + 1);

  onFrequencyChange(event: any) {
    console.log(
      'Selected Frequency:',
      this.lodgeComplaintTicket.controls.selectedFrequency.value
    );
    console.log('Selected Days:', this.selectedDays);
    console.log('Selected Dates:', this.selectedDates);
  }
  selectionLimit(event: MatSelectChange, type: 'day' | 'date') {
    const selectedFrequency =
      this.lodgeComplaintTicket.controls.selectedFrequency.value;
    const maxSelection =
      selectedFrequency === 'twiceAWeek' || selectedFrequency === 'twiceAMonth'
        ? 2
        : null;

    if (maxSelection && event.source.value.length > maxSelection) {
      // Remove the first selected item to keep only two selections
      event.source.value.shift();
      this.lodgeComplaintTicket.controls[
        type === 'day' ? 'selectedDays' : 'selectedDates'
      ].setValue([...event.source.value]);
    }
  }
  get selected() {
    return this.lodgeComplaintTicket.get('SelectedUsers') as FormArray;
  }
  addUser(event: any): void {
    const value = event.option.value;
    if (value && !this.usersTemp.includes(value)) {
      this.usersTemp.push(value);
      const matchedUser = this.data.find(
        (user) =>
          (user.firstname + ' ' + user.lastname).toLowerCase() ===
          value.toLowerCase()
      );
      const item = {
        HostName:
          matchedUser.firstname.trim() + ' ' + matchedUser.lastname.trim(),
        HostUserId: matchedUser.userId,
        HostEmail: matchedUser.email,
        HostPhone: matchedUser.phoneNumber,
      };
      this.selected.push(this.formbuilder.control(item));
    }
    setTimeout(() => {
      this.selectedUsersControl.setValue('');
    }, 250);
    event.option.deselect();
  }
  clearInputField(): void {
    this.selectedUsersControl.setValue(''); // Clear the input field value
  }
  removeUser(user: string): void {
    const index = this.usersTemp.indexOf(user);
    const formArray = this.lodgeComplaintTicket.get(
      'SelectedUsers'
    ) as FormArray;
    if (index >= 0) {
      this.usersTemp.splice(index, 1);
      formArray.removeAt(index);
    }
  }
}
export interface ISelectedAttachments {
  selectedAttachment: File;
  attachedContent: string;
  attachedContentName: string;
  attachedContentType: string;
}
function lowerCaseFirstLetterOfKeys(obj: any): any {
  return Object.keys(obj).reduce((acc: any, key: string) => {
    const newKey = key.charAt(0).toLowerCase() + key.slice(1);
    acc[newKey] = obj[key];
    return acc;
  }, {});
}
